const modalsMixin = {
    data: function () {
        return {    
            modals: {
                addToCart: null,
                review: null,
                dimensions: null,
                askAQuestion: null,
                quote: null,
                productRedirect: null,
                edgeFinishing: null,
                roundCorners: null,
                drilledHoles: null
            }
        };
    },
    mixins: [generalMixin],
    methods: {
        /**
         * Retrieves or creates a modal instance based on the provided modalId and instanceKey.
         *
         * @param {string} modalId - The ID of the modal element.
         * @param {string} instanceKey - The key used to store the modal instance in the modals object.
         * @param {string} backdrop - defaults to static. Options are also true/false. See bootstrap for other options.
         * @return {BSN.Modal} The modal instance.
         */
        getOrCreateModal: function (modalId, instanceKey, backdrop = 'static') {
            const modalElement = document.querySelector(modalId);

            if (!this.modals[instanceKey] && modalElement) {
                this.$set(this.modals, instanceKey, new BSN.Modal(modalElement, {
                    backdrop: backdrop,
                }));
            }

            if (modalElement) {
                modalElement.addEventListener('show.bs.modal', (event) => {
                    this.lazyLoadImages(modalElement);
                });
            }

            return this.modals[instanceKey];
        },
        addToCartModal: function () {
            return this.getOrCreateModal('#vueAddToCartModal', 'addToCart');
        },
        reviewModal: function () {
            return this.getOrCreateModal('#vueReviewModal', 'review');
        },
        dimensionsModal: function () {
            return this.getOrCreateModal('#vueDimensionsModal', 'dimensions');
        },
        askAQuestionModal: function () {
            return this.getOrCreateModal('#vueAskAQuestionModal', 'askAQuestion');
        },
        quoteModal: function () {
            return this.getOrCreateModal('#vueQuoteModal', 'quote');
        },
        productRedirectModal: function () {
            return this.getOrCreateModal('#vueRedirectProductModal', 'productRedirect');
        },
        edgeFinishingModal: function () {
            return this.getOrCreateModal('#vueEdgeFinishingModal', 'edgeFinishing', true);
        },
        roundCornersModal: function () {
            return this.getOrCreateModal('#vueRoundCornersModal', 'roundCorners', true);
        },
        drilledHolesModal: function () {
            return this.getOrCreateModal('#vueDrilledHolesModal', 'drilledHoles', true);
        },
        lazyLoadImages: function (el) {
            const images = el.querySelectorAll("[data-lazyload]");
            images.forEach((img) => {
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                }
                if (img.dataset.srcset) {
                    img.srcset = img.dataset.srcset;
                }
                img.setAttribute("data-loaded", "true");
                img.classList.add("loaded");
            });
        }
    },
};
